import { Grid, Image, Popover, Typography } from 'antd';
import React from 'react';

const { Text, Link } = Typography;
const { useBreakpoint } = Grid;

interface AuthorHoverCardProps {
  name: string;
  image: string;
  description: string;
  profileLink: string;
}

const AuthorHoverCard: React.FC<AuthorHoverCardProps> = ({
  name,
  image,
  description,
  profileLink,
}) => {
  const screens = useBreakpoint();

  const content = (
    <div className='w-[400px] flex items-start gap-3'>
      <div className='min-w-20 min-h-20'>
        <Image
          src={image}
          alt={name}
          width={80}
          height={80}
          style={{ borderRadius: 8, objectFit: 'cover' }}
          preview={false}
        />
      </div>

      <div>
        <Text>{description}</Text>
        <br />
        <Link href={profileLink} target='_blank' style={{ color: '#fa541c' }}>
          View Profile
        </Link>
      </div>
    </div>
  );

  const triggerText = (
    <Text style={{ color: '#fa541c', cursor: 'pointer' }} className='text-sm'>
      {name}
    </Text>
  );

  if (!screens.md) {
    return (
      <Link href={profileLink} style={{ color: '#fa541c' }} target='_blank'>
        {name}
      </Link>
    );
  }

  return (
    <Popover
      content={content}
      title={null}
      trigger='hover'
      placement='bottom'
      arrow={false}
    >
      {triggerText}
    </Popover>
  );
};

export default AuthorHoverCard;
